var map = {
	"./1955_Nascita HP.jpg": 4312,
	"./1967_Mara.jpg": 7503,
	"./1969_Leonardo da Vinci.jpg": 7237,
	"./1971_Minimoto.jpg": 4032,
	"./1973_Buggie.jpg": 5501,
	"./1976_Taller.jpg": 2530,
	"./1978_Caravan.jpg": 7693,
	"./1979_Monoposto F2.jpg": 5764,
	"./1982_Rugosimetro.jpg": 6527,
	"./1983_Fangio.jpg": 3958,
	"./1984_Countach Evoluzione.jpg": 4374,
	"./1986_P140.jpg": 1537,
	"./1988_Countach Anniversario.jpg": 5999,
	"./1990_Diablo.jpg": 401,
	"./1991_Modena Design.jpg": 1796,
	"./1993_C8.jpg": 8567,
	"./1995_Next.jpg": 60,
	"./1997_Formula 1.jpg": 3921,
	"./1998_Pagani Automobili.jpg": 5018,
	"./1999_Zonda.jpg": 9040,
	"./2000_Zonda S.jpg": 7335,
	"./2003_Zonda S Roadster.jpg": 5942,
	"./2005_Zonda F.jpg": 2251,
	"./2006_Zonda Roadster F.jpg": 1376,
	"./2009_Zonda Cinque.jpg": 5515,
	"./2009_Zonda R.jpg": 1744,
	"./2010_Zonda Cinque Roadster.jpg": 1997,
	"./2010_Zonda Tricolore.jpg": 7984,
	"./2011_Huayra.jpg": 7309,
	"./2013_Zonda Revolucion.jpg": 7358,
	"./2016_Huayra BC.jpg": 2100,
	"./2017_Atelier.jpg": 6317,
	"./2017_Huayra Roadster.jpg": 9704,
	"./2017_Museo.jpg": 6862,
	"./2017_Nuova sede esterno.jpg": 2823,
	"./2017_Zonda HP Barchetta.jpg": 7033,
	"./2018_Laurea.jpg": 1091,
	"./2019_Centro di Ricerca.jpg": 722,
	"./2019_Roadster BC.jpg": 2440,
	"./2019_Zonda Revo Barchetta.jpg": 5032,
	"./2020_Huayra Tricolore.jpg": 2930,
	"./2020_Imola.jpg": 8982,
	"./2021_Huayra R.jpg": 5128,
	"./2022_Arte in Pista.jpg": 2947,
	"./2022_Codalunga.jpg": 3735,
	"./2022_Compasso d_oro.jpg": 8856,
	"./2022_Utopia.jpg": 2235,
	"./2023_Codalunga Award.jpg": 4375,
	"./2023_Imola Roadster.jpg": 4882,
	"./2024_Utopia_Roadster.jpg": 8391,
	"./2025_Codalunga_Speedster.jpg": 6637,
	"./2025_Huayra_R_EVO.jpg": 2177,
	"./2025_Laurea_Horacio.jpg": 7633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1656;